import React, { Component } from "react";

/**
 * 
 */
class ButtonReImprimir extends Component {
    constructor(props) {
        super(props);
    }
    /**
     * 
     */
    render() {
        /*Atributos*/
        const { novedad, puedeEjecutar } = this.props;
        let componente = null;
        //let puedeEjecutar = false;

        /*si existe una novedad que fue recuperada entonces puede ver los detalles de la tarjeta, de lo contrario tiene que revisar 
        las demas validaciones DEPRECADO v0*/
        //if (novedad.novedadBaja == undefined && novedad.novedadRecuperada) {
        //    puedeEjecutar = true;
        //} else {
        //    puedeEjecutar = (novedad.novedadBaja == undefined
        //        && novedad.novedadBloqueda == undefined
        //        && novedad.validacionBaja == false
        //        && novedad.validacionBloqueo == false)
        //}

        /*Si hay novedad de baja o si ésta fue aprobada por la administradora no hay funcionalidad disponible*/
        if (puedeEjecutar == false) {
            componente = (
                <a className="none-text-decoration ti-printer disabled"></a>
            );
        } else {
            componente = (
                <a className="clickable none-text-decoration ti-printer"></a>
            );
        }

        return componente;
    }
}

export default ButtonReImprimir;